<template>
  <p>{{ text }}</p>
</template>

<script>
export default {
  name: "BaseText",
  props: {
    text: String,

    default() {
      return { text: "This iz zome placeholder text" };
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");

p {
  line-height: 1.7 !important;
  margin: 10px;
  font-family: "Orbitron";
}
</style>
